"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _formFields = require("@trodly/form-fields");

var _constant = require("../constant");

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

var _membersModule = _interopRequireDefault(require("./styles/members.module.css"));

var _loginModule = _interopRequireDefault(require("./styles/login.module.css"));

var _Icons = require("../util/Icons");

var _actions = require("../actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MembersDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MembersDetail, _React$Component);

  function MembersDetail(props) {
    var _this;

    _classCallCheck(this, MembersDetail);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MembersDetail).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onMessageChange", function (text) {
      _this.setState({
        message: text
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEmailChange", function (text) {
      _this.setState({
        email: text
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPhoneChange", function (text) {
      _this.setState({
        phone: text
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCountryCodeChange", function (text) {
      _this.setState({
        countryCode: text
      });
    });

    _defineProperty(_assertThisInitialized(_this), "incrementAdult", function () {
      _this.setState(function (prev) {
        return {
          nrAdults: prev.nrAdults + 1
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementAdult", function () {
      var nrAdults = _this.state.nrAdults;

      if (nrAdults <= 1) {
        _this.setState({
          nrAdults: 1
        });
      } else {
        _this.setState(function (prev) {
          return {
            nrAdults: prev.nrAdults - 1
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "incrementChild", function () {
      _this.setState(function (prev) {
        return {
          nrChild: prev.nrChild + 1
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementChild", function () {
      var nrChild = _this.state.nrChild;

      if (nrChild <= 0) {
        _this.setState({
          nrChild: 0
        });
      } else {
        _this.setState(function (prev) {
          return {
            nrChild: prev.nrChild - 1
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveMembers", function () {
      var _this$state = _this.state,
          nrAdults = _this$state.nrAdults,
          message = _this$state.message,
          nrChild = _this$state.nrChild,
          email = _this$state.email,
          phone = _this$state.phone,
          countryCode = _this$state.countryCode;
      var _this$props = _this.props,
          setMembers = _this$props.setMembers,
          setEmail = _this$props.setEmail,
          setPhone = _this$props.setPhone,
          setCountryCode = _this$props.setCountryCode,
          setComment = _this$props.setComment,
          registerEnquiry = _this$props.registerEnquiry,
          userDetails = _this$props.userDetails,
          nextStep = _this$props.nextStep;

      if (nrAdults && message.length > 30 && email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && phone.length > 0) {
        setMembers({
          nrAdults: nrAdults,
          nrChild: nrChild
        });
        setComment(message);
        setCountryCode(countryCode);
        setPhone(phone);
        setEmail(email);

        if (userDetails.phone_verified === 'yes' && userDetails.phone === phone && userDetails.countryCode === countryCode) {
          var members = {
            nrAdults: nrAdults,
            nrChild: nrChild
          };
          var _this$props2 = _this.props,
              _userDetails = _this$props2.userDetails,
              source = _this$props2.source,
              enquiryFor = _this$props2.enquiryFor,
              date = _this$props2.date;
          registerEnquiry(enquiryFor, date, members, message, source, _userDetails, email, phone, countryCode);
        } else {
          _this.setState({
            sendingOTP: true
          }); // Send OTP


          var formData = new FormData();
          formData.append("id", _this.props.userDetails.id);
          formData.append("firstName", _this.props.userDetails.first_name);
          formData.append("lastName", _this.props.userDetails.last_name);
          formData.append("email", _this.state.email);
          formData.append("phone", _this.state.phone);
          formData.append("countryCode", _this.state.countryCode);
          formData.append("password", null);
          fetch("".concat(_constant.API_ROOT, "sendotp.php"), {
            credentials: "same-origin",
            method: "POST",
            body: formData
          }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
            if (data.status) {
              // Go to OPT verification
              nextStep();
            } else {
              // Error
              _this.setState({
                error: true,
                sendingOTP: false
              });
            }
          }).catch(function (err) {
            return console.log(err);
          });
        }
      }
    });

    _this.state = {
      nrAdults: 1,
      nrChild: 0,
      message: "",
      email: "",
      phone: "",
      countryCode: "91",
      error: false,
      sendingOTP: false
    };
    return _this;
  }

  _createClass(MembersDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          comment = _this$props3.comment,
          members = _this$props3.members;
      this.setState({
        nrAdults: members.nrAdults,
        nrChild: members.nrChild,
        message: comment,
        email: this.props.userDetails.email,
        phone: this.props.userDetails.phone,
        countryCode: this.props.userDetails.countryCode || "91"
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (Object.getOwnPropertyNames(prevProps.userDetails).length === 0 && Object.getOwnPropertyNames(this.props.userDetails).length !== 0) {
        this.setState({
          email: this.props.userDetails.email,
          phone: this.props.userDetails.phone,
          countryCode: this.props.userDetails.countryCode
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          nrAdults = _this$state2.nrAdults,
          nrChild = _this$state2.nrChild,
          message = _this$state2.message,
          email = _this$state2.email,
          phone = _this$state2.phone,
          error = _this$state2.error,
          sendingOTP = _this$state2.sendingOTP;
      var registering = this.props.registering;
      var nextAllowed = true;

      if (nrAdults && message.length > 30 && email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && phone.length > 0) {
        nextAllowed = false;
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: "".concat(_baseModule.default.heading2, " ").concat(_baseModule.default.greenText),
        style: {
          marginBottom: "1.25rem"
        }
      }, "Who all are going?"), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentBetween, " ").concat(_baseModule.default.alignItemsCenter, " ").concat(_membersModule.default.memberCountContainer)
      }, _react.default.createElement("div", {
        className: _membersModule.default.description
      }, _react.default.createElement("p", {
        className: "".concat(_baseModule.default.paragraph, " ").concat(_baseModule.default.bold)
      }, "Adults"), _react.default.createElement("p", {
        className: _baseModule.default.small
      }, "(18yr & above)")), _react.default.createElement(MemberCount, {
        count: nrAdults,
        increment: this.incrementAdult,
        decrement: this.decrementAdult
      })), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentBetween, " ").concat(_baseModule.default.alignItemsCenter, " ").concat(_membersModule.default.memberCountContainer)
      }, _react.default.createElement("div", {
        className: _membersModule.default.description
      }, _react.default.createElement("p", {
        className: "".concat(_baseModule.default.paragraph, " ").concat(_baseModule.default.bold)
      }, "Children"), _react.default.createElement("p", {
        className: _baseModule.default.small
      }, "(2yr to 17yr)")), _react.default.createElement(MemberCount, {
        count: nrChild,
        increment: this.incrementChild,
        decrement: this.decrementChild
      })), _react.default.createElement("div", {
        className: _baseModule.default.label
      }, "E-mail address:"), _react.default.createElement("div", {
        className: _baseModule.default.inputHolder
      }, _react.default.createElement("div", {
        className: _baseModule.default.iconedInputHolder
      }, _react.default.createElement(_formFields.Input, {
        type: "email",
        name: "email",
        className: _baseModule.default.input,
        value: this.props.userDetails.email,
        onChange: this.onEmailChange
      }), _react.default.createElement(_Icons.EmailIcon, null)), _react.default.createElement("p", {
        className: "".concat(_baseModule.default.tiny, " ").concat(_baseModule.default.inputNotification),
        style: {
          marginTop: "-20px"
        }
      }, _react.default.createElement(_Icons.CircularTickIcon, {
        width: "0.75rem",
        color: "#484848"
      }), _react.default.createElement("span", null, "All details will be sent to this email address"))), _react.default.createElement("div", {
        className: _baseModule.default.label
      }, "Contact number:"), _react.default.createElement("div", {
        className: _baseModule.default.inputHolder
      }, _react.default.createElement("div", {
        className: _baseModule.default.iconedInputHolder
      }, _react.default.createElement(_formFields.PhoneField, {
        name: "phone",
        placeholder: "Your mobile number",
        className: _baseModule.default.input,
        value: this.props.userDetails.phone,
        countryCode: this.props.userDetails.countryCode,
        onPhoneChange: function onPhoneChange(e) {
          return _this2.onPhoneChange(e.target.value);
        },
        onCountryCodeChange: this.onCountryCodeChange
      }), _react.default.createElement(_Icons.PhoneIcon, null)), _react.default.createElement("p", {
        className: "".concat(_baseModule.default.tiny, " ").concat(_baseModule.default.inputNotification)
      }, _react.default.createElement(_Icons.CircularTickIcon, {
        width: "0.75rem",
        color: "#484848"
      }), _react.default.createElement("span", null, "Verification code will be sent to the provided contact."))), _react.default.createElement("div", {
        className: "".concat(_membersModule.default.messageContainer)
      }, _react.default.createElement("div", {
        className: _baseModule.default.label
      }, "Your enquiry"), _react.default.createElement("textarea", {
        value: message,
        onChange: function onChange(e) {
          return _this2.onMessageChange(e.target.value);
        },
        rows: "4",
        placeholder: "Describe your request with full details"
      }), _react.default.createElement("p", {
        className: _baseModule.default.tiny
      }, "Minimum 30 character")), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentEnd)
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock,
        style: {
          marginRight: "15px"
        }
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, "OTP code could not be sent. Try again")) : "", _react.default.createElement(_formFields.Button, {
        text: "Submit",
        type: "button",
        primary: true,
        disabled: nextAllowed,
        onClick: this.saveMembers,
        isLoading: registering || sendingOTP
      })));
    }
  }]);

  return MembersDetail;
}(_react.default.Component);

var MemberCount = function MemberCount(_ref) {
  var count = _ref.count,
      increment = _ref.increment,
      decrement = _ref.decrement;
  return _react.default.createElement("div", {
    className: _membersModule.default.container
  }, _react.default.createElement("div", {
    className: _membersModule.default.actions,
    onClick: decrement
  }, _react.default.createElement(_Icons.MinusIcon, {
    width: "1rem",
    color: "#fff"
  })), _react.default.createElement("div", {
    className: _membersModule.default.count
  }, count), _react.default.createElement("div", {
    className: _membersModule.default.actions,
    onClick: increment
  }, _react.default.createElement(_Icons.PlusIcon, {
    width: "1rem",
    color: "#fff"
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    comment: state.comment,
    members: state.members,
    email: state.email,
    phone: state.phone,
    countryCode: state.countryCode,
    userDetails: state.userDetails,
    source: state.source,
    enquiryFor: state.enquiryFor,
    date: state.date,
    registering: state.registering
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setMembers: function setMembers(members) {
      return dispatch((0, _actions.setMembers)(members));
    },
    setPhone: function setPhone(phone) {
      return dispatch((0, _actions.setPhone)(phone));
    },
    setCountryCode: function setCountryCode(countryCode) {
      return dispatch((0, _actions.setCountryCode)(countryCode));
    },
    setEmail: function setEmail(email) {
      return dispatch((0, _actions.setEmail)(email));
    },
    nextStep: function nextStep() {
      return dispatch((0, _actions.nextStep)());
    },
    setComment: function setComment(comment) {
      return dispatch((0, _actions.setComment)(comment));
    },
    registerEnquiry: function registerEnquiry(enquiry, date, members, comment, source, user, email, phone, countryCode) {
      return dispatch((0, _actions.registerEnquiry)(enquiry, date, members, comment, source, user, email, phone, countryCode));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MembersDetail);

exports.default = _default;